export const PRIMARY_ERRORS_FOR_ACTIVE_PRODUCT = {
  ProductName: {
    fieldFullPath: 'ProductName',
    displayName: 'Product Name',
    fullPathDisplayName: 'Product Name',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  ProductDescription: {
    fieldFullPath: 'ProductDescription',
    displayName: 'Product Description',
    fullPathDisplayName: 'Product Description',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  Gtin: {
    fieldFullPath: 'Gtin',
    displayName: 'GTIN',
    fullPathDisplayName: 'GTIN',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  Upc8: {
    fieldFullPath: 'Upc8',
    displayName: 'Upc8',
    fullPathDisplayName: 'Upc8',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  Upc12: {
    fieldFullPath: 'Upc12',
    displayName: 'Upc12',
    fullPathDisplayName: 'Upc12',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  Upc13: {
    fieldFullPath: 'Upc13',
    displayName: 'Upc13',
    fullPathDisplayName: 'Upc13',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  NetContentsValue: {
    fieldFullPath: 'NetContentsValue',
    displayName: 'Net Contents Value',
    fullPathDisplayName: 'Net Contents Value',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'int32',
  },
  NetContentsUom: {
    fieldFullPath: 'NetContentsUom',
    displayName: 'Net Content UOM',
    fullPathDisplayName: 'Net Content UOM',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
    listName: 'BasicUomEnum',
  },
  NetContentsStatement: {
    fieldFullPath: 'NetContentsStatement',
    displayName: 'Net Contents Statement',
    fullPathDisplayName: 'Net Contents Statement',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  BrickCode: {
    fieldFullPath: 'BrickCode',
    displayName: 'Brick Code',
    fullPathDisplayName: 'Brick Code',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  PrimarySize: {
    fieldFullPath: 'PrimarySize',
    displayName: 'Primary Size',
    fullPathDisplayName: 'Primary Size',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'int32',
  },
  PrimarySizeUOM: {
    fieldFullPath: 'PrimarySizeUOM',
    displayName: 'Primary Size UOM',
    fullPathDisplayName: 'Primary Size UOM',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
    listName: 'BasicUomEnum',
  },
  CountryOfOrigin: {
    fieldFullPath: 'CountryOfOrigin',
    displayName: 'Country of Origin',
    fullPathDisplayName: 'Country of Origin',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'select',
    listName: 'CountryCodeEnum',
    mode: 'multiple',
  },
  Width: {
    fieldFullPath: 'Width',
    displayName: 'Width',
    fullPathDisplayName: 'Width',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'int32',
  },
  Height: {
    fieldFullPath: 'Height',
    displayName: 'Height',
    fullPathDisplayName: 'Height',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'int32',
  },
  Depth: {
    fieldFullPath: 'Depth',
    displayName: 'Depth',
    fullPathDisplayName: 'Depth',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'int32',
  },
  Weight: {
    fieldFullPath: 'Weight',
    displayName: 'Weight',
    fullPathDisplayName: 'Weight',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'int32',
  },
  AverageWeight: {
    fieldFullPath: 'AverageWeight',
    displayName: 'Average Weight',
    fullPathDisplayName: 'Average Weight',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'int32',
  },
  DimensionUOM: {
    fieldFullPath: 'DimensionUOM',
    displayName: 'Dimension UOM',
    fullPathDisplayName: 'Dimension UOM',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
    listName: 'BasicUomEnum',
  },
  WeightUOM: {
    fieldFullPath: 'WeightUOM',
    displayName: 'Weight UOM',
    fullPathDisplayName: 'Weight UOM',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
    listName: 'BasicUomEnum',
  },
  UnitCount: {
    fieldFullPath: 'UnitCount',
    displayName: 'Unit Count',
    fullPathDisplayName: 'Unit Count',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'int32',
  },
  TargetMarket: {
    fieldFullPath: 'TargetMarket',
    displayName: 'Target Market',
    fullPathDisplayName: 'Target Market',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
    listName: 'BasicUomEnum',
  },
  BrandId: {
    fieldFullPath: 'BrandId',
    displayName: 'Brand Name',
    fullPathDisplayName: 'Brand Name',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'String',
  },
  FrontPlanogramImageId: {
    fieldFullPath: 'FrontPlanogramImageId',
    displayName: 'Front Planogram',
    fullPathDisplayName: 'Front Planogram',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
  LeftPlanogramImageId: {
    fieldFullPath: 'LeftPlanogramImageId',
    displayName: 'Left Planogram',
    fullPathDisplayName: 'Left Planogram',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
  RightPlanogramImageId: {
    fieldFullPath: 'RightPlanogramImageId',
    displayName: 'Right Planogram',
    fullPathDisplayName: 'Right Planogram',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
  BackPlanogramImageId: {
    fieldFullPath: 'BackPlanogramImageId',
    displayName: 'Back Planogram',
    fullPathDisplayName: 'Back Planogram',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
  TopPlanogramImageId: {
    fieldFullPath: 'TopPlanogramImageId',
    displayName: 'Top Planogram',
    fullPathDisplayName: 'Top Planogram',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
  BottomPlanogramImageId: {
    fieldFullPath: 'BottomPlanogramImageId',
    displayName: 'Bottom Planogram',
    fullPathDisplayName: 'Bottom Planogram',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
  FrontMarketingImageId: {
    fieldFullPath: 'FrontMarketingImageId',
    displayName: 'Front Marketing',
    fullPathDisplayName: 'Front Marketing',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
  LeftMarketingImageId: {
    fieldFullPath: 'LeftMarketingImageId',
    displayName: 'Left Marketing',
    fullPathDisplayName: 'Left Marketing',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
  RightMarketingImageId: {
    fieldFullPath: 'RightMarketingImageId',
    displayName: 'Right Marketing',
    fullPathDisplayName: 'Right Marketing',
    moduleDisplayName: 'Product Basic Information',
    dataType: 'Image',
  },
};
